class ReportsApiResponseModel {
  // #region Props
  id;
  Titulo;
  alias;
  urlInforme;
  descripcion;
  Categoria;
  tieneCabecera;
  habilitado;
  habilitadoDesde;
  comentable;
  esPublico;
  publicoDesde;
  publicoHasta;
  tieneRoles;
  IdInforme;
  Permisos;
  tipoInforme;
  queryText;
  PiePagina;
  usuarios;
  Roles;
  Filtros;
  Estadisticas;
  Graficos;
  tieneLandingPage;
  URL;
  DescripcionGeneral;
  accesosInforme;
  Archivos;
  prefiltrar;
  mostrarTabs;
  mostrarFiltros;
  GuidReportPowerBI;
  visible;
  publicoPrivado;
  // #endregion

  constructor(object) {
    // Assign props to this object instance
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        const element = object[key];
        this[key] = element;
      }

      if (key == "tiene_cabecera") {
        this.tieneCabecera = element;
      }
    }
  }

  // #region Private methods
  // #endregion
}

export default ReportsApiResponseModel;
